import { render, staticRenderFns } from "./FinalOrderModal.vue?vue&type=template&id=d6ec1644&"
import script from "./FinalOrderModal.vue?vue&type=script&lang=ts&"
export * from "./FinalOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QTable,QTd,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QTable,QTd,QCardActions})
